/******/ (() => { // webpackBootstrap
/*!*********************************************************!*\
  !*** ./zrc/scripts/templates/page-book-sleeve-video.js ***!
  \*********************************************************/
class PageBookSleeveVideo extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.init();
  }
  init() {
    $(document).on('closed', '.remodal', () => {
      $('.video-iframe').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
    });
    var videoIframe = this.container.querySelectorAll(".pbs-video-iframe");
    videoIframe.forEach(element => {
      element.addEventListener("load", () => {
        element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        element.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      });
    });
  }
}
if (window.customElements.get('page-book-sleeve-video') == null) {
  window.customElements.define('page-book-sleeve-video', PageBookSleeveVideo);
}
/******/ })()
;